<div class="page-body">
  <div>
    <header
    [breadcrumbPath]="breadcrumb"
    [accountType]="getCurrentAccountType()"
    ></header>
    <div class="page-content is-fullpage" >
      <div *ngIf="isLoaded">
        <login-form 
          [accountType]="accountType"
          [prefilledEmail]="prefilledEmail"
          (onLoginAttempt)="trackLoginAttempted()"
        ></login-form>
      </div>
    </div>
  </div>
  <footer [hasLinks]="true"></footer>
</div>
